export const ERROR_MESSAGES = {
    'emptyCode': 'El campo "Código de Confirmación" es requerido',
}

export const CONFIRM_DONE = 'El código de confirmación ha sido comprobado de manera exitosa.'
export const CODE_MISTMATCHED_ERROR = 'El código proporcionado no es correcto.'